<script>
import Base from "@/components/RequestDetails/EstateData.vue";

export default {
  name: "CustomerServiceEstateData",
  extends: Base,
};
</script>

